import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export interface PageLoaderProps {
  message?: string;
  fullScreen?: boolean;
}

function PageLoader({ message, fullScreen = true }: PageLoaderProps) {
  const { t } = useTranslation('common');
  const displayMessage = message || t('status.loading', 'Loading...');

  return (
    <div
      className={`flex flex-col items-center justify-center bg-light-bg dark:bg-dark-bg
        ${fullScreen ? 'min-h-screen' : 'min-h-[200px]'}`}
      role="status"
      aria-live="polite"
    >
      <Loader2 className="h-12 w-12 text-accent-600 dark:text-accent-400 animate-spin mb-4" />
      <p className="text-light-muted dark:text-dark-muted text-sm font-medium">
        {displayMessage}
      </p>
    </div>
  );
}

export default PageLoader;
